import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { RouterModule} from '@angular/router';
import { MomentModule } from 'ngx-moment';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { OrderModule } from 'ngx-order-pipe';
import { NouisliderModule } from 'ng2-nouislider';

import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { SortablejsModule } from 'angular-sortablejs';
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { AppComponent } from './app.component';
import { PlacesComponent } from './components/places/places.component';
import { AccountsComponent } from './components/accounts/accounts.component';
import { LayersComponent } from './components/layers/layers.component';
import { RoutesComponent } from './components/routes/routes.component';
import { LassoComponent } from './components/lasso/lasso.component';
import { MapService } from './core/map/map.service';
import { MapComponent } from './components/map/map.component';
import { InfoPanelComponent } from './components/info-panel/info-panel.component';
import { ReportsComponent } from './components/reports/reports.component';
import { SettingsComponent } from './components/settings/settings.component';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';
import {FieldsService} from './core/fields/fields.service';
import {NewAccountComponent} from './components/shared/new-account/new-account.component';
import {AccountsService} from './core/accounts/accounts.service';
import {AccountDetailsComponent } from './components/info-panel/account-details/account-details.component';
import {PlaceComponent } from './components/info-panel/place/place.component';
import {CheckinsService} from './core/checkins/checkins.service';
import {LoginComponent } from './components/login/login.component';
import {RegisterComponent } from './components/register/register.component';
import {AuthService} from './core/auth/auth.service';
import {appRoutes} from './app.routes';
import {MainComponent } from './components/main/main.component';
import {AuthGuardService} from './core/guards/auth-guard';
import {UnauthGuardService} from './core/guards/unauth-guard';
import {AuthInterceptor} from './core/auth-interceptor/auth-interceptor.service';
import {RoutesService} from './core/routes/routes.service';
import {PlacesService} from './core/places/places.service';
import { PointComponent } from './components/routes/point/point.component';
import { SupremePointComponent } from './components/routes/supreme-point/supreme-point.component';
import {UtilsService} from './core/utils/utils.service';
import { TimeComponent } from './routes/shared/time/time.component';
import { LengthComponent } from './routes/shared/length/length.component';
import { AutocompleteComponent } from './components/shared/autocomplete/autocomplete.component';
import {EditableFieldComponent} from './components/shared/editable-field/editable-field.component';
import { CustomEditableFieldComponent } from './components/shared/custom-editable-field/custom-editable-field.component';
import { FieldValueComponent } from './components/shared/field-value/field-value.component';
import {NavigationService} from './core/navigation/navigation.service';
import { UsersComponent } from './components/settings/users/users.component';
import { FieldsComponent } from './components/settings/fields/fields.component';
import {UsersService} from './core/users/users.service';
import { UserComponent } from './components/settings/users/user/user.component';
import { VisualizeComponent } from './components/visualize/visualize.component';
import { FieldFilterComponent } from './components/visualize/field-filter/field-filter.component';
import { OnlyNumberDirective } from './directives/only-number/only-number.directive';
import { SettingsService} from './core/settings/settings.service';
import {TooltipModule} from 'ngx-bootstrap';
import { UploadComponent } from './components/settings/upload/upload.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { UpdatePlanComponent } from './components/update-plan/update-plan.component';
import { PlanExpirationGuard} from './core/guards/plan-expiration-guard';
import { BuyPlanComponent } from './components/shared/buy-plan/buy-plan.component';
import { ChangeCardComponent } from './components/change-card/change-card.component';




@NgModule({
  declarations: [
    AppComponent,
    PlacesComponent,
    AccountsComponent,
    LayersComponent,
    RoutesComponent,
    LassoComponent,
    MapComponent,
    InfoPanelComponent,
    ReportsComponent,
    SettingsComponent,
    NewAccountComponent,
    AccountDetailsComponent,
    PlaceComponent,
    LoginComponent,
    RegisterComponent,
    MainComponent,
    PointComponent,
    SupremePointComponent,
    TimeComponent,
    LengthComponent,
    AutocompleteComponent,
    EditableFieldComponent,
    CustomEditableFieldComponent,
    FieldValueComponent,
    UsersComponent,
    FieldsComponent,
    UserComponent,
    VisualizeComponent,
    FieldFilterComponent,
    OnlyNumberDirective,
    UploadComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    UpdatePlanComponent,
    BuyPlanComponent,
    ChangeCardComponent,

  ],
  entryComponents: [NewAccountComponent],
  imports: [
    BrowserModule,
    RouterModule.forRoot(appRoutes),
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FilterPipeModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    TooltipModule.forRoot(),
    CollapseModule.forRoot(),
    MomentModule,

    OrderModule,

    SortablejsModule.forRoot({}),

    NouisliderModule,
    
  ],
  providers: [
    MapService,
    FieldsService,
    AccountsService,
    PlacesService,
    CheckinsService,
    RoutesService,
    NavigationService,
    UtilsService,
    AuthService,
    UsersService,
    SettingsService,
    AuthGuardService,
    UnauthGuardService,
    PlanExpirationGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./client/app/app.module.ts